import { Link, useParams } from 'react-router-dom'

import { RoundsTable } from '../components/rounds.tsx'
import { Card, CardBody, CardHead, LoadError, PageHead, Skeleton } from '../components/ui.tsx'
import { usePageTitle } from '../layout/AppShell.tsx'
import { useApi } from '../lib/api.ts'
import type { PlayerPayload } from '../../shared/types.ts'

/** One player's full round history, as every signed-in player sees it. */
export function Player() {
  const { playerId = '' } = useParams()
  const { data, error, loading, reload } = useApi<PlayerPayload>(`/players/${encodeURIComponent(playerId)}`, 60_000)
  usePageTitle(data?.name ?? 'Player')

  if (error) return <main className="content"><LoadError error={error} onRetry={reload} /></main>
  if (loading || !data) {
    return (
      <main className="content">
        <Card>
          <CardBody>
            <Skeleton rows={6} />
          </CardBody>
        </Card>
      </main>
    )
  }

  const busts = data.rounds.filter((r) => r.status === 'bust').length
  return (
    <main className="content">
      <PageHead
        breadcrumb={
          <>
            <Link to="/leaderboard">Leaderboard</Link> / {data.name}
          </>
        }
        title={data.you ? `${data.name} (you)` : data.name}
        sub={`${data.rounds.length} round${data.rounds.length === 1 ? '' : 's'} · ${busts} went to zero`}
      />
      <Card>
        <CardHead title="Rounds" sub="Newest first. Rounds are permanent — they cannot be deleted." />
        <CardBody flush>
          <RoundsTable rounds={data.rounds} />
        </CardBody>
      </Card>
    </main>
  )
}
